import React, { useState } from 'react';
import { FaUser, FaLock } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = ({ setIsAuthenticated, setBillingAddress }) => {
    const [loginData, setLoginData] = useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post('https://afric-fresh-backend.onrender.com/auth/login', loginData);
            
            localStorage.setItem('AficFreshtoken', response.data.token);
            localStorage.setItem('AficFreshuserDetails', JSON.stringify(response.data.user));
            
            setIsAuthenticated(true);
            toast.success('Login successful! You can now complete your checkout.');
            
            setBillingAddress(prev => ({
                ...prev,
                firstName: response.data.user.firstName || '',
                lastName: response.data.user.lastName || '',
                email: response.data.user.email || '',
                phone: response.data.user.phoneNumber || '',
                streetHouseApartment: response.data.user.address?.streetHouseApartment || '',
                city: response.data.user.address?.city || '',
                state: response.data.user.address?.state || '',
                zipCode: response.data.user.address?.zipCode || '',
            }));
        } catch (error) {
            toast.error(error.response?.data?.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <div className="text-center mb-8">
                        <h2 className="text-3xl font-extrabold text-gray-900">
                            Login Required
                        </h2>
                        <p className="mt-2 text-sm text-gray-600">
                            Please login to complete your checkout process
                        </p>
                    </div>

                    <form className="space-y-6" onSubmit={handleLogin}>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Email
                            </label>
                            <div className="mt-1 relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <FaUser className="text-gray-400" />
                                </div>
                                <input
                                    type="email"
                                    required
                                    className="focus:ring-[#007D44] focus:border-[#007D44] block w-full pl-10 sm:text-sm border-gray-300 rounded-md p-2 border"
                                    placeholder="Enter your email"
                                    value={loginData.email}
                                    onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Password
                            </label>
                            <div className="mt-1 relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <FaLock className="text-gray-400" />
                                </div>
                                <input
                                    type="password"
                                    required
                                    className="focus:ring-[#007D44] focus:border-[#007D44] block w-full pl-10 sm:text-sm border-gray-300 rounded-md p-2 border"
                                    placeholder="Enter your password"
                                    value={loginData.password}
                                    onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#007D44] hover:bg-[#006D34] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#007D44]"
                            >
                                {loading ? 'Logging in...' : 'Login'}
                            </button>
                        </div>
                    </form>

                    <div className="mt-6">
                        <div className="relative">
                            <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-gray-300" />
                            </div>
                            <div className="relative flex justify-center text-sm">
                                <span className="px-2 bg-white text-gray-500">
                                    Don't have an account?
                                </span>
                            </div>
                        </div>

                        <div className="mt-6">
                            <button
                                onClick={() => navigate('/auth/signup')}
                                className="w-full flex justify-center py-2 px-4 border border-[#007D44] rounded-md shadow-sm text-sm font-medium text-[#007D44] bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#007D44]"
                            >
                                Sign up
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;